import { useSuspenseQuery } from "@tanstack/react-query"
import { createFileRoute } from "@tanstack/react-router"
import { SegmentEditor } from "@/components/audience/segment-editor"
import { fieldsQuery, segmentQuery, tagsQuery } from "@/lib/queries"

export const Route = createFileRoute("/w/$workspace/contacts/segments/$segmentId")({
  loader: ({ context, params }) => Promise.all([context.queryClient.ensureQueryData(segmentQuery(params.workspace, params.segmentId)), context.queryClient.ensureQueryData(tagsQuery(params.workspace)), context.queryClient.ensureQueryData(fieldsQuery(params.workspace))]),
  component: SegmentEditRoute,
})

function SegmentEditRoute() {
  const { workspace, segmentId } = Route.useParams()
  const segment = useSuspenseQuery(segmentQuery(workspace, segmentId)).data
  return <SegmentEditor key={segment.id} segment={segment} />
}
